// export const API_URL = 'https://ftmo-api-dev.buso.asia';
// export const API_URL = 'https://ftmo-real-api.buso.asia';

export const is_dev = false; // Set to true for development, false for production
export const is_local = false; // Set to true for local development (using localhost API), false for using remote API

export const API_URL_DEV = 'https://ftmo-api-dev.buso.asia';
export const API_URL_PROD = 'https://ftmo-real-api.buso.asia';
export const API_URL_LOCAL = 'http://192.168.1.103:8002';
export const API_URL_LOCAL_2 = 'http://192.168.137.1:8002';



export const API_URL = is_local ? API_URL_LOCAL : (is_dev ? API_URL_DEV : API_URL_PROD);

///
export const API_URL_3 = 'https://78534d12e343.ngrok-free.app';
export const BOT_ZIGZAG_URL = 'http://localhost:3000';
export const INDEX_SENTIMENT_URL = 'https://chart.index.wealthfarming.org/';


export const DOMAIN_API = 'beq.busodevelopers.com'
export const SITE_ID = 343
export const API_URL_v2 = 'https://fund-forge-api.wealthfarming.org';

export const API_URL_IMAGE = 'http://beq-image.buso.asia';
export const LIMIT_EXPORT_EXCEL = 10000
export const API_GET_IMAGE = ''

export const REACT_APP_PAYPAL_MODE = 'sandbox' // sandbox for dev, live for real
export const BOT_TELEGRAM = 'sandbox' // sandbox for dev, live for real

export const Web3_ENV: "testnet" | "mainnet" = 'testnet' // testnet for dev, mainnet for real

export const DOCKER_RUN_API_URL = 'https://lumir.ccpi.vn/api/docker/run';
export const DOCKER_KEY = "SNX9nYECHt0TAYFdisIN0E2Y-1Dp4ZEl6B0KUVscOdLq1NrRqckguwTdNq4Ty5yiaIvZVLB4oPCJOelL4bRoAg"